import {HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Provider} from "@angular/core";
import {FirebaseAuthenticationService} from "./firebase-authentication.service";
import {from, Observable, switchMap} from "rxjs";


@Injectable()
export class FirebaseAuthenticatorInterceptor implements HttpInterceptor {

  constructor(private authService: FirebaseAuthenticationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Convert getToken (which returns a Promise) to an Observable
    return from(this.authService.getToken()).pipe(
      switchMap(token => {
        if (token) {
          // console.log("Adding bearer token to request. Token: " + token)

          // Clone the request to add the new header
          const clonedRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          // Pass the cloned request instead of the original request to the next handler
          return next.handle(clonedRequest);
        }

        // If there's no token, just forward the original request
        return next.handle(request);
      })
    );
  }
}
